module.exports = __webpack_public_path__ + "static/media/content.59a54a2d.svg";